import { render, staticRenderFns } from "./SavedConfig.vue?vue&type=template&id=1da1f6ed&scoped=true"
import script from "./SavedConfig.vue?vue&type=script&lang=js"
export * from "./SavedConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1f6ed",
  null
  
)

export default component.exports